export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Inicio',
        to: '/inicio',
        icon: 'cil-speedometer',        
      },      
      {
        _name: 'CSidebarNavItem',
        name: 'Pedidos',
        to: '/pedidos/pedido',
        icon: 'cil-pencil'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Financeiro',
        to: '/documentos/documento',
        icon: 'cil-dollar'
      },
    ] 
  }
]